import { BidPaymentStatus } from "api";
const accountsReceivableReportDemo = () => {
    return Promise.resolve({
        isDynamic: false,
        columns: [
            {
                index: null,
                label: "Номер заявки",
                propertyName: "BidId",
                clrType: "int64",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Контрагент",
                propertyName: "CounterpartyId",
                clrType: "int64",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: true,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Контрагент",
                propertyName: "CounterpartyName",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Стоимость заявки",
                propertyName: "Price",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Машина",
                propertyName: "CarId",
                clrType: "int64",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: true,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Машина",
                propertyName: "CarNumber",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Маршрут",
                propertyName: "Route",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Дата выставления счета",
                propertyName: "InvoiceDate",
                clrType: "dateonly",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Плановая дата оплаты",
                propertyName: "PlanPaymentDate",
                clrType: "dateonly",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Фактическая дата оплаты",
                propertyName: "FactPaymentDate",
                clrType: "dateonly",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Статус оплаты",
                propertyName: "BidPaymentStatusReadable",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Комментарий",
                propertyName: "Comment",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Полученные платежи",
                propertyName: "ReceivedAmountByDate",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Ожидаемые платежи",
                propertyName: "PendingPaymentsByDate",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Организация",
                propertyName: "LegalPersonId",
                clrType: "int64",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: true,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Организация",
                propertyName: "LegalPersonName",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
        ],
        data: [
            {
                bidId: 9457631,
                counterpartyId: 10781716,
                counterpartyName: "ООО Грузовые решения",
                price: 150000.0,
                carId: 10912389,
                carNumber: "А539ВС/64",
                route: "Казань - Уфа",
                invoiceDate: "2025-12-01",
                planPaymentDate: "2025-12-05",
                factPaymentDate: "2025-12-02",
                overdueDays: 0,
                bidPaymentStatus: "Paid",
                bidPaymentStatusReadable: "Оплачен",
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 150000.0,
                pendingPaymentsByDate: 0.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
            {
                bidId: 9457632,
                counterpartyId: 10783082,
                counterpartyName: "ООО Надежный груз",
                price: 250000.0,
                carId: 10912388,
                carNumber: "О064СУ/56",
                route: "Москва - посёлок Шушары",
                invoiceDate: "2025-11-27",
                planPaymentDate: "2025-12-04",
                factPaymentDate: "2025-12-05",
                overdueDays: 1,
                bidPaymentStatus: "Paid",
                bidPaymentStatusReadable: "Оплачен",
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 250000.0,
                pendingPaymentsByDate: 0.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
            {
                bidId: 9457644,
                counterpartyId: 10783082,
                counterpartyName: "ООО Надежный груз",
                price: 240000.0,
                carId: 10912381,
                carNumber: "В548АС/42",
                route: "Екатеринбург - Томск",
                invoiceDate: "2025-11-17",
                planPaymentDate: "2025-11-29",
                factPaymentDate: null,
                overdueDays: 4,
                bidPaymentStatus: "PartiallyPaid",
                bidPaymentStatusReadable: "Частичная оплата",
                isPaymentOverdue: true,
                remainingPayment: 70000.0,
                comment: null,
                receivedAmountByDate: 170000.0,
                pendingPaymentsByDate: 70000.0,
                legalPersonId: 1002,
                legalPersonName: "ИП Иванов",
            },
            {
                bidId: 9457636,
                counterpartyId: 10781722,
                counterpartyName: "ООО Магистраль Групп",
                price: 300000.0,
                carId: 10912385,
                carNumber: "У307РУ/91",
                route: "Владивосток - Чита",
                invoiceDate: "2025-12-05",
                planPaymentDate: "2025-12-10",
                factPaymentDate: null,
                overdueDays: 0,
                bidPaymentStatus: "NotPaid",
                bidPaymentStatusReadable: "Не оплачен",
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 0.0,
                pendingPaymentsByDate: 300000.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
            {
                bidId: 9457641,
                counterpartyId: 10781726,
                counterpartyName: "ООО Грузоперевозки Плюс",
                price: 165000.0,
                carId: 10912384,
                carNumber: "С517УК/55",
                route: "Казань - Домодедово",
                invoiceDate: "2025-11-22",
                planPaymentDate: "2025-12-02",
                factPaymentDate: "2025-12-01",
                overdueDays: 0,
                bidPaymentStatus: "Paid",
                bidPaymentStatusReadable: "Оплачен",
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 165000.0,
                pendingPaymentsByDate: 0.0,
                legalPersonId: 1002,
                legalPersonName: "ИП Иванов",
            },
            {
                bidId: 9457642,
                counterpartyId: 10781715,
                counterpartyName: "ООО Логистик-Сервис",
                price: 600000.0,
                carId: 10912383,
                carNumber: "В897УР/51",
                route: "Москва - Владивосток",
                invoiceDate: "2025-11-21",
                planPaymentDate: "2025-11-28",
                factPaymentDate: "2025-11-29",
                overdueDays: 1,
                bidPaymentStatus: "Paid",
                bidPaymentStatusReadable: "Оплачен",
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 600000.0,
                pendingPaymentsByDate: 0.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
            {
                bidId: 9457643,
                counterpartyId: 10781716,
                counterpartyName: "ООО Грузовые решения",
                price: 150000.0,
                carId: 10912382,
                carNumber: "А935АУ/07",
                route: "Уфа - Тюмень",
                invoiceDate: "2025-11-28",
                planPaymentDate: "2025-12-05",
                factPaymentDate: null,
                overdueDays: 0,
                bidPaymentStatus: "PartiallyPaid",
                bidPaymentStatusReadable: "Частичная оплата",
                remainingPayment: 50000.0,
                comment: null,
                receivedAmountByDate: 100000.0,
                pendingPaymentsByDate: 50000.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
            {
                bidId: 9457633,
                counterpartyId: 10783082,
                counterpartyName: "ООО Надежный груз",
                price: 175000.0,
                carId: 10912387,
                carNumber: "М960ТС/56",
                route: "Омск - Томск",
                invoiceDate: "2025-11-24",
                planPaymentDate: "2025-12-02",
                factPaymentDate: null,
                overdueDays: 1,
                bidPaymentStatus: "NotPaid",
                bidPaymentStatusReadable: "Не оплачен",
                isPaymentOverdue: true,
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 0.0,
                pendingPaymentsByDate: 175000.0,
                legalPersonId: 1002,
                legalPersonName: "ИП Иванов",
            },
            {
                bidId: 9457634,
                counterpartyId: 10781722,
                counterpartyName: "ООО Магистраль Групп",
                price: 100000.0,
                carId: 10912386,
                carNumber: "М841КН/06",
                route: "Иркутск - Чита",
                invoiceDate: "2025-11-20",
                planPaymentDate: "2025-11-25",
                factPaymentDate: null,
                overdueDays: 8,
                bidPaymentStatus: "NotPaid",
                bidPaymentStatusReadable: "Не оплачен",
                isPaymentOverdue: true,
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 0.0,
                pendingPaymentsByDate: 100000.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
            {
                bidId: 9457645,
                counterpartyId: 10781727,
                counterpartyName: "ООО ЛогистикПлюс",
                price: 100000.0,
                carId: 10912380,
                carNumber: "Р365ТУ/45",
                route: "Воронеж - Ростов-на-Дону",
                invoiceDate: "2025-11-27",
                planPaymentDate: "2025-12-03",
                factPaymentDate: "2025-12-03",
                overdueDays: 0,
                bidPaymentStatus: "Paid",
                bidPaymentStatusReadable: "Оплачен",
                remainingPayment: null,
                comment: null,
                receivedAmountByDate: 100000.0,
                pendingPaymentsByDate: 0.0,
                legalPersonId: 1002,
                legalPersonName: "ИП Иванов",
            },
            {
                bidId: 9457646,
                counterpartyId: 10781727,
                counterpartyName: "ООО ЛогистикПлюс",
                price: 250000.0,
                carId: 10912379,
                carNumber: "М905СУ/61",
                route: "Липецк - Ульяновск",
                invoiceDate: "2025-12-02",
                planPaymentDate: "2025-12-06",
                factPaymentDate: null,
                overdueDays: 0,
                bidPaymentStatus: "PartiallyPaid",
                bidPaymentStatusReadable: "Частичная оплата",
                remainingPayment: 80000.0,
                comment: null,
                receivedAmountByDate: 170000.0,
                pendingPaymentsByDate: 80000.0,
                legalPersonId: 1001,
                legalPersonName: "ООО Трансавто плюс",
            },
        ].map((row, index) => ({
            ...row,
            isDistributionBid: false,
            remainingAmount: row.bidPaymentStatus === BidPaymentStatus.Paid ? 0 : (row.remainingPayment ?? row.price),
            isChecked: false,
            isPaymentOverdue: row.bidPaymentStatus !== BidPaymentStatus.Paid && !!row.isPaymentOverdue,
            previousDayPayment: [null, 100000, 30000, null, 20000][index % 5],
        })),
        footer: {},
        footerAdditionalInfo: {
            data: {
                pendingPayments: 775000.0,
                receivedAmount: 1535000.0,
                totalDebt: 345000.0,
            },
            columns: [
                {
                    index: null,
                    label: "Ожидаемые поступления",
                    propertyName: "PendingPayments",
                    clrType: "double",
                    ignoreInGroup: false,
                    isSubGroup: false,
                    isSubModel: false,
                    aggregateType: "None",
                    cellType: "Default",
                    isAdditionalColumn: false,
                    isEntityId: false,
                    metadata: {},
                    isFooterData: false,
                    canBeMerged: false,
                    width: 1,
                },
                {
                    index: null,
                    label: "Поступило",
                    propertyName: "ReceivedAmount",
                    clrType: "double",
                    ignoreInGroup: false,
                    isSubGroup: false,
                    isSubModel: false,
                    aggregateType: "None",
                    cellType: "Default",
                    isAdditionalColumn: false,
                    isEntityId: false,
                    metadata: {},
                    isFooterData: false,
                    canBeMerged: false,
                    width: 1,
                },
                {
                    index: null,
                    label: "Задолженность",
                    propertyName: "TotalDebt",
                    clrType: "double",
                    ignoreInGroup: false,
                    isSubGroup: false,
                    isSubModel: false,
                    aggregateType: "None",
                    cellType: "Default",
                    isAdditionalColumn: false,
                    isEntityId: false,
                    metadata: {},
                    isFooterData: false,
                    canBeMerged: false,
                    width: 1,
                },
            ],
        },
        generatedAt: "2025-12-03T11:34:30.9653016+00:00",
        errorMessage: null,
        onlyAdditionalFooter: true,
        id: "AccountsReceivableReport",
        name: "Взаиморасчёты",
    });
};

const incomesAndExpensesReportDemo = () => {
    return Promise.resolve({
        isDynamic: false,
        columns: [
            {
                index: null,
                label: "Машина",
                propertyName: "CarNumber",
                clrType: "string",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Доходы поступившие",
                propertyName: "Incomes",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "Sum",
                cellType: "Numeric",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Ожидаемые поступления",
                propertyName: "ExpectedIncomes",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "Sum",
                cellType: "Numeric",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Дебиторка",
                propertyName: "Debit",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "Sum",
                cellType: "Numeric",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Всего расходов",
                propertyName: "Expenses",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "Sum",
                cellType: "Numeric",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: "Сальдо",
                propertyName: "Balance",
                clrType: "double",
                ignoreInGroup: false,
                isSubGroup: false,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Numeric",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: null,
                propertyName: "Cars",
                clrType: "incomesandexpensescarmodel[]",
                ignoreInGroup: false,
                isSubGroup: true,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: null,
                propertyName: "Trailers",
                clrType: "incomesandexpensestrailermodel[]",
                ignoreInGroup: false,
                isSubGroup: true,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: null,
                propertyName: "Drivers",
                clrType: "incomesandexpensesdrivermodel[]",
                ignoreInGroup: false,
                isSubGroup: true,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
            {
                index: null,
                label: null,
                propertyName: "Bids",
                clrType: "incomesandexpensesbidmodel[]",
                ignoreInGroup: false,
                isSubGroup: true,
                isSubModel: false,
                aggregateType: "None",
                cellType: "Default",
                isAdditionalColumn: false,
                isEntityId: false,
                metadata: {},
                isFooterData: false,
                canBeMerged: false,
                width: 1,
            },
        ],
        data: [
            {
                carNumber: "М841КН/06",
                incomes: 700000.0,
                expectedIncomes: 120000.0,
                debit: -100000.0,
                expenses: 344400.0,
                balance: 355600.0,
                cars: [
                    {
                        carNumber: "М841КН/06",
                        name: "9457634",
                        value: -60000.0,
                    },
                    {
                        carNumber: "М841КН/06",
                        name: "9458051",
                        value: 700000.0,
                    },
                    {
                        carNumber: "М841КН/06",
                        name: "Лизинг",
                        value: -60000.0,
                    },
                    {
                        carNumber: "М841КН/06",
                        name: "Расходы на топливо",
                        value: -150000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "СТ6539/77",
                        name: "Ремонт пола",
                        value: -7200.0,
                    },
                    {
                        trailerNumber: "СТ6539/77",
                        name: "Замена лампочки",
                        value: -300.0,
                    },
                    {
                        trailerNumber: "СТ6539/77",
                        name: "Смазка осей",
                        value: -1200.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Федоров М. Д.",
                        name: "Зарплата",
                        value: -42000.0,
                    },
                    {
                        driverName: "Федоров М. Д.",
                        name: "Суточные",
                        value: -12000.0,
                    },
                    {
                        driverName: "Федоров М. Д.",
                        name: "Премия",
                        value: -6000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457634,
                        name: "Услуги грузчиков",
                        value: -3000.0,
                    },
                    {
                        bidId: 9457634,
                        name: "Платная парковка",
                        value: -900.0,
                    },
                    {
                        bidId: 9457634,
                        name: "Дополнительная упаковка",
                        value: -1800.0,
                    },
                ],
            },
            {
                carNumber: "С517УК/55",
                incomes: 170000.0,
                expectedIncomes: 2833489.4,
                debit: -50000.0,
                expenses: 377500.0,
                balance: -207500.0,
                cars: [
                    {
                        carNumber: "С517УК/55",
                        name: "9457641",
                        value: 165000.0,
                    },
                    {
                        carNumber: "С517УК/55",
                        name: "Лизинг",
                        value: -150000.0,
                    },
                    {
                        carNumber: "С517УК/55",
                        name: "ТО",
                        value: -70000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "КМ5678/99",
                        name: "Замена колеса",
                        value: -15000.0,
                    },
                    {
                        trailerNumber: "КМ5678/99",
                        name: "Ремонт электрики",
                        value: -5000.0,
                    },
                    {
                        trailerNumber: "КМ5678/99",
                        name: "Мойка",
                        value: -2500.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Лебедев Т. Н.",
                        name: "Зарплата",
                        value: -100000.0,
                    },
                    {
                        driverName: "Лебедев Т. Н.",
                        name: "Квартальная премия",
                        value: -25000.0,
                    },
                    {
                        driverName: "Лебедев Т. Н.",
                        name: "Компенсация питания",
                        value: -5000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457641,
                        name: "Простой",
                        value: 5000.0,
                    },
                    {
                        bidId: 9457641,
                        name: "Перерасход топлива",
                        value: -2000.0,
                    },
                    {
                        bidId: 9457641,
                        name: "Штраф за опоздание",
                        value: -3000.0,
                    },
                ],
            },
            {
                carNumber: "В548АС/42",
                incomes: 450000.0,
                expectedIncomes: 200000.0,
                debit: 0.0,
                expenses: 658000.0,
                balance: -208000.0,
                cars: [
                    {
                        carNumber: "В548АС/42",
                        name: "9457644",
                        value: -240000.0,
                    },
                    {
                        carNumber: "В548АС/42",
                        name: "9458053",
                        value: 250000.0,
                    },
                    {
                        carNumber: "В548АС/42",
                        name: "9458052",
                        value: 200000.0,
                    },
                    {
                        carNumber: "В548АС/42",
                        name: "Лизинг",
                        value: -150000.0,
                    },
                    {
                        carNumber: "В548АС/42",
                        name: "Ремонт",
                        value: -85000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "ОВ7356/103",
                        name: "Стоянка",
                        value: -15000.0,
                    },
                    {
                        trailerNumber: "ОВ7356/103",
                        name: "Мойка",
                        value: -2000.0,
                    },
                    {
                        trailerNumber: "ОВ7356/103",
                        name: "Ремонт электрики",
                        value: -5000.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Иванов С. Ф.",
                        name: "Зарплата",
                        value: -100000.0,
                    },
                    {
                        driverName: "Иванов С. Ф.",
                        name: "Аванс",
                        value: -30000.0,
                    },
                    {
                        driverName: "Иванов С. Ф.",
                        name: "Доплата за стаж",
                        value: -10000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9458052,
                        name: "Стоянка",
                        value: -15000.0,
                    },
                    {
                        bidId: 9458052,
                        name: "Питание водителя",
                        value: -5000.0,
                    },
                    {
                        bidId: 9458052,
                        name: "Телефонная связь",
                        value: -1000.0,
                    },
                ],
            },
            {
                carNumber: "Р365ТУ/45",
                incomes: 140000.0,
                expectedIncomes: 728443.8,
                debit: 0.0,
                expenses: 105000.0,
                balance: 35000.0,
                cars: [
                    {
                        carNumber: "Р365ТУ/45",
                        name: "9457645",
                        value: 140000.0,
                    },
                    {
                        carNumber: "Р365ТУ/45",
                        name: "Лизинг",
                        value: -24000.0,
                    },
                    {
                        carNumber: "Р365ТУ/45",
                        name: "Страховка",
                        value: -6000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "АЕ1234/45",
                        name: "Стоянка",
                        value: -3000.0,
                    },
                    {
                        trailerNumber: "АЕ1234/45",
                        name: "Страховка",
                        value: -6000.0,
                    },
                    {
                        trailerNumber: "АЕ1234/45",
                        name: "Тех осмотр",
                        value: -1800.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Смирнов А. А.",
                        name: "Зарплата",
                        value: -36000.0,
                    },
                    {
                        driverName: "Смирнов А. А.",
                        name: "Командировочные",
                        value: -9000.0,
                    },
                    {
                        driverName: "Смирнов А. А.",
                        name: "Материальная помощь",
                        value: -3000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457645,
                        name: "Суточные",
                        value: -6000.0,
                    },
                    {
                        bidId: 9457645,
                        name: "Гостиница",
                        value: -9000.0,
                    },
                    {
                        bidId: 9457645,
                        name: "Такси",
                        value: -1200.0,
                    },
                ],
            },
            {
                carNumber: "О064СУ/56",
                incomes: 350000.0,
                expectedIncomes: 80000.0,
                debit: -12000.0,
                expenses: 165300.0,
                balance: 184700.0,
                cars: [
                    {
                        carNumber: "О064СУ/56",
                        name: "9457632",
                        value: 350000.0,
                    },
                    {
                        carNumber: "О064СУ/56",
                        name: "Лизинг",
                        value: -78000.0,
                    },
                    {
                        carNumber: "О064СУ/56",
                        name: "Страховка КАСКО",
                        value: -30000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "ВК5678/56",
                        name: "Ремонт тента",
                        value: -12000.0,
                    },
                    {
                        trailerNumber: "ВК5678/56",
                        name: "Замена фонаря",
                        value: -900.0,
                    },
                    {
                        trailerNumber: "ВК5678/56",
                        name: "Мойка",
                        value: -1500.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Петров П. П.",
                        name: "Премия",
                        value: -9000.0,
                    },
                    {
                        driverName: "Петров П. П.",
                        name: "Оклад",
                        value: -27000.0,
                    },
                    {
                        driverName: "Петров П. П.",
                        name: "Надбавка за сложность",
                        value: -3000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457632,
                        name: "Платная дорога",
                        value: -3000.0,
                    },
                    {
                        bidId: 9457632,
                        name: "Весовой контроль",
                        value: -600.0,
                    },
                    {
                        bidId: 9457632,
                        name: "Экологический сбор",
                        value: -300.0,
                    },
                ],
            },
            {
                carNumber: "А539ВС/64",
                incomes: 150000.0,
                expectedIncomes: 45000.0,
                debit: -8000.0,
                expenses: 149000.0,
                balance: 1000.0,
                cars: [
                    {
                        carNumber: "А539ВС/64",
                        name: "9457631",
                        value: 150000.0,
                    },
                    {
                        carNumber: "А539ВС/64",
                        name: "Замена масла",
                        value: -15000.0,
                    },
                    {
                        carNumber: "А539ВС/64",
                        name: "Фильтры",
                        value: -5000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "ВР4182/64",
                        name: "Шиномонтаж",
                        value: -8000.0,
                    },
                    {
                        trailerNumber: "ВР4182/64",
                        name: "Балансировка",
                        value: -2000.0,
                    },
                    {
                        trailerNumber: "ВР4182/64",
                        name: "Подкачка шин",
                        value: -500.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Кузнецов В. И.",
                        name: "Зарплата",
                        value: -65000.0,
                    },
                    {
                        driverName: "Кузнецов В. И.",
                        name: "Компенсация проезда",
                        value: -3000.0,
                    },
                    {
                        driverName: "Кузнецов В. И.",
                        name: "Бонус за экономию",
                        value: -7000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457631,
                        name: "ГСМ",
                        value: -40000.0,
                    },
                    {
                        bidId: 9457631,
                        name: "Присадки",
                        value: -2000.0,
                    },
                    {
                        bidId: 9457631,
                        name: "Антифриз",
                        value: -1500.0,
                    },
                ],
            },
            {
                carNumber: "М960ТС/56",
                incomes: 50000.0,
                expectedIncomes: 35000.0,
                debit: 0.0,
                expenses: 306500.0,
                balance: -256500.0,
                cars: [
                    {
                        carNumber: "М960ТС/56",
                        name: "9457633",
                        value: -175000.0,
                    },
                    {
                        carNumber: "М960ТС/56",
                        name: "Штраф ГИБДД",
                        value: -5000.0,
                    },
                    {
                        carNumber: "М960ТС/56",
                        name: "Эвакуатор",
                        value: -15000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "МР3456/56",
                        name: "Мойка",
                        value: -3000.0,
                    },
                    {
                        trailerNumber: "МР3456/56",
                        name: "Дезинфекция",
                        value: -5000.0,
                    },
                    {
                        trailerNumber: "МР3456/56",
                        name: "Пломбировка",
                        value: -1000.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Соколов Д. С.",
                        name: "Аванс",
                        value: -20000.0,
                    },
                    {
                        driverName: "Соколов Д. С.",
                        name: "Расчет",
                        value: -40000.0,
                    },
                    {
                        driverName: "Соколов Д. С.",
                        name: "Отпускные",
                        value: -25000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457633,
                        name: "Продажа паллет",
                        value: 50000.0,
                    },
                    {
                        bidId: 9457633,
                        name: "Командировочные",
                        value: -12000.0,
                    },
                    {
                        bidId: 9457633,
                        name: "Представительские расходы",
                        value: -5000.0,
                    },
                    {
                        bidId: 9457633,
                        name: "Почтовые расходы",
                        value: -500.0,
                    },
                ],
            },
            {
                carNumber: "В897УР/51",
                incomes: 650000.0,
                expectedIncomes: 842770.3,
                debit: -60000.0,
                expenses: 301000.0,
                balance: 349000.0,
                cars: [
                    {
                        carNumber: "В897УР/51",
                        name: "9457642",
                        value: 600000.0,
                    },
                    {
                        carNumber: "В897УР/51",
                        name: "Лизинг",
                        value: -160000.0,
                    },
                    {
                        carNumber: "В897УР/51",
                        name: "Страховка ОСАГО",
                        value: -15000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "СТ7890/51",
                        name: "Запчасти",
                        value: -25000.0,
                    },
                    {
                        trailerNumber: "СТ7890/51",
                        name: "Работа мастера",
                        value: -10000.0,
                    },
                    {
                        trailerNumber: "СТ7890/51",
                        name: "Расходные материалы",
                        value: -3000.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Михайлов М. Н.",
                        name: "Зарплата",
                        value: -70000.0,
                    },
                    {
                        driverName: "Михайлов М. Н.",
                        name: "Премия",
                        value: -10000.0,
                    },
                    {
                        driverName: "Михайлов М. Н.",
                        name: "Доплата за переработку",
                        value: -5000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457642,
                        name: "Обратная загрузка",
                        value: 50000.0,
                    },
                    {
                        bidId: 9457642,
                        name: "Доставка документов",
                        value: -1000.0,
                    },
                    {
                        bidId: 9457642,
                        name: "Курьерские услуги",
                        value: -2000.0,
                    },
                ],
            },
            {
                carNumber: "У307РУ/91",
                incomes: 120000.0,
                expectedIncomes: 2833489.4,
                debit: 0.0,
                expenses: 430000.0,
                balance: -310000.0,
                cars: [
                    {
                        carNumber: "У307РУ/91",
                        name: "Лизинг",
                        value: -120000.0,
                    },
                    {
                        carNumber: "У307РУ/91",
                        name: "Техническое обслуживание",
                        value: -25000.0,
                    },
                    {
                        carNumber: "У307РУ/91",
                        name: "Ремонт двигателя",
                        value: -150000.0,
                    },
                ],
                trailers: [
                    {
                        trailerNumber: "ХА1122/91",
                        name: "Страховка",
                        value: -15000.0,
                    },
                    {
                        trailerNumber: "ХА1122/91",
                        name: "Аренда стоянки",
                        value: -5000.0,
                    },
                    {
                        trailerNumber: "ХА1122/91",
                        name: "Охрана",
                        value: -2000.0,
                    },
                ],
                drivers: [
                    {
                        driverName: "Новиков А. В.",
                        name: "Зарплата",
                        value: -60000.0,
                    },
                    {
                        driverName: "Новиков А. В.",
                        name: "Командировочные",
                        value: -20000.0,
                    },
                    {
                        driverName: "Новиков А. В.",
                        name: "Материальная помощь",
                        value: -15000.0,
                    },
                ],
                bids: [
                    {
                        bidId: 9457636,
                        name: "Возврат страховки",
                        value: 120000.0,
                    },
                    {
                        bidId: 9457636,
                        name: "Штраф",
                        value: -5000.0,
                    },
                    {
                        bidId: 9457636,
                        name: "Юридические услуги",
                        value: -10000.0,
                    },
                    {
                        bidId: 9457636,
                        name: "Судебные издержки",
                        value: -3000.0,
                    },
                ],
            },
            {
                carNumber: "К492МН/77",
                incomes: 210000.0,
                expectedIncomes: 55000.0,
                debit: 0.0,
                expenses: 200000.0,
                balance: 10000.0,
                cars: [
                    { carNumber: "К492МН/77", name: "Лизинг", value: -100000.0 },
                    { carNumber: "К492МН/77", name: "Страховка", value: -20000.0 },
                    { carNumber: "К492МН/77", name: "ТО", value: -10000.0 },
                ],
                trailers: [
                    { trailerNumber: "АЕ4821/77", name: "Стоянка", value: -5000.0 },
                    { trailerNumber: "АЕ4821/77", name: "Мойка", value: -2000.0 },
                    { trailerNumber: "АЕ4821/77", name: "Ремонт", value: -3000.0 },
                ],
                drivers: [
                    { driverName: "Иванов И. И.", name: "Зарплата", value: -40000.0 },
                    { driverName: "Иванов И. И.", name: "Суточные", value: -10000.0 },
                    { driverName: "Иванов И. И.", name: "Премия", value: -5000.0 },
                ],
                bids: [
                    { bidId: 1000001, name: "Фрахт", value: 200000.0 },
                    { bidId: 1000001, name: "Догруз", value: 10000.0 },
                    { bidId: 1000001, name: "Штраф", value: -5000.0 },
                ],
            },
            {
                carNumber: "О194ТМ/50",
                incomes: 252000.0,
                expectedIncomes: 40000.0,
                debit: 0.0,
                expenses: 153000.0,
                balance: 99000.0,
                cars: [
                    { carNumber: "О194ТМ/50", name: "Топливо", value: -48000.0 },
                    { carNumber: "О194ТМ/50", name: "Ремонт", value: -30000.0 },
                    { carNumber: "О194ТМ/50", name: "Шины", value: -12000.0 },
                ],
                trailers: [
                    { trailerNumber: "ВК9153/50", name: "Тент", value: -6000.0 },
                    { trailerNumber: "ВК9153/50", name: "Электрика", value: -3000.0 },
                    { trailerNumber: "ВК9153/50", name: "Ось", value: -9000.0 },
                ],
                drivers: [
                    { driverName: "Петров П. П.", name: "Зарплата", value: -30000.0 },
                    { driverName: "Петров П. П.", name: "Штраф", value: -3000.0 },
                    { driverName: "Петров П. П.", name: "Аванс", value: -6000.0 },
                ],
                bids: [
                    { bidId: 1000002, name: "Перевозка", value: 252000.0 },
                    { bidId: 1000002, name: "Опоздание", value: -3000.0 },
                    { bidId: 1000002, name: "Брак", value: -3000.0 },
                ],
            },
            {
                carNumber: "Т831ХЕ/99",
                incomes: 308000.0,
                expectedIncomes: 70000.0,
                debit: -25000.0,
                expenses: 136200.0,
                balance: 171800.0,
                cars: [
                    { carNumber: "Т831ХЕ/99", name: "Лизинг", value: -54000.0 },
                    { carNumber: "Т831ХЕ/99", name: "КАСКО", value: -18000.0 },
                    { carNumber: "Т831ХЕ/99", name: "Платон", value: -6000.0 },
                ],
                trailers: [
                    { trailerNumber: "ЕМ2674/99", name: "Колодки", value: -4800.0 },
                    { trailerNumber: "ЕМ2674/99", name: "Диски", value: -7200.0 },
                    { trailerNumber: "ЕМ2674/99", name: "Смазка", value: -1200.0 },
                ],
                drivers: [
                    { driverName: "Сидоров С. С.", name: "Зарплата", value: -36000.0 },
                    { driverName: "Сидоров С. С.", name: "Связь", value: -600.0 },
                    { driverName: "Сидоров С. С.", name: "Питание", value: -4200.0 },
                ],
                bids: [
                    { bidId: 1000003, name: "Рейс Мск-Спб", value: 308000.0 },
                    { bidId: 1000003, name: "Экспедирование", value: -3000.0 },
                    { bidId: 1000003, name: "Въезд", value: -1200.0 },
                ],
            },
            {
                carNumber: "В572РН/16",
                incomes: 150000.0,
                expectedIncomes: 35000.0,
                debit: 0.0,
                expenses: 107500.0,
                balance: 42500.0,
                cars: [
                    { carNumber: "В572РН/16", name: "Топливо", value: -40000.0 },
                    { carNumber: "В572РН/16", name: "Мойка", value: -2000.0 },
                    { carNumber: "В572РН/16", name: "Стоянка", value: -3000.0 },
                ],
                trailers: [
                    { trailerNumber: "КХ5938/16", name: "Фонарь", value: -1000.0 },
                    { trailerNumber: "КХ5938/16", name: "Крыло", value: -4000.0 },
                    { trailerNumber: "КХ5938/16", name: "Брызговик", value: -1000.0 },
                ],
                drivers: [
                    { driverName: "Козлов А. А.", name: "Зарплата", value: -40000.0 },
                    { driverName: "Козлов А. А.", name: "Премия", value: -5000.0 },
                    { driverName: "Козлов А. А.", name: "Командировка", value: -10000.0 },
                ],
                bids: [
                    { bidId: 1000004, name: "Доставка", value: 150000.0 },
                    { bidId: 1000004, name: "Пропуск", value: -1000.0 },
                    { bidId: 1000004, name: "Весы", value: -500.0 },
                ],
            },
            {
                carNumber: "А638КО/66",
                incomes: 300000.0,
                expectedIncomes: 90000.0,
                debit: 0.0,
                expenses: 297000.0,
                balance: 3000.0,
                cars: [
                    { carNumber: "А638КО/66", name: "Кап.ремонт", value: -150000.0 },
                    { carNumber: "А638КО/66", name: "Эвакуатор", value: -30000.0 },
                    { carNumber: "А638КО/66", name: "Сервис", value: -20000.0 },
                ],
                trailers: [
                    { trailerNumber: "МТ8246/66", name: "Покраска", value: -15000.0 },
                    { trailerNumber: "МТ8246/66", name: "Сварка", value: -10000.0 },
                    { trailerNumber: "МТ8246/66", name: "Ворота", value: -5000.0 },
                ],
                drivers: [
                    { driverName: "Новиков Б. Б.", name: "Зарплата", value: -45000.0 },
                    { driverName: "Новиков Б. Б.", name: "Больничный", value: -5000.0 },
                    { driverName: "Новиков Б. Б.", name: "Проезд", value: -2000.0 },
                ],
                bids: [
                    { bidId: 1000005, name: "Негабарит", value: 300000.0 },
                    { bidId: 1000005, name: "Сопровождение", value: -10000.0 },
                    { bidId: 1000005, name: "Разрешение", value: -5000.0 },
                ],
            },
            {
                carNumber: "С925МУ/34",
                incomes: 168000.0,
                expectedIncomes: 30000.0,
                debit: 0.0,
                expenses: 84000.0,
                balance: 84000.0,
                cars: [
                    { carNumber: "С925МУ/34", name: "Топливо", value: -30000.0 },
                    { carNumber: "С925МУ/34", name: "Масло", value: -6000.0 },
                    { carNumber: "С925МУ/34", name: "Фильтр", value: -3000.0 },
                ],
                trailers: [
                    { trailerNumber: "ОН1592/34", name: "Шина", value: -12000.0 },
                    { trailerNumber: "ОН1592/34", name: "Диск", value: -6000.0 },
                    { trailerNumber: "ОН1592/34", name: "Монтаж", value: -3000.0 },
                ],
                drivers: [
                    { driverName: "Морозов В. В.", name: "Зарплата", value: -18000.0 },
                    { driverName: "Морозов В. В.", name: "Штраф ГИБДД", value: -1500.0 },
                    { driverName: "Морозов В. В.", name: "Удержание", value: -1500.0 },
                ],
                bids: [
                    { bidId: 1000006, name: "Город", value: 168000.0 },
                    { bidId: 1000006, name: "Грузчики", value: -2400.0 },
                    { bidId: 1000006, name: "Упаковка", value: -600.0 },
                ],
            },
            {
                carNumber: "Е417ТХ/78",
                incomes: 250000.0,
                expectedIncomes: 65000.0,
                debit: 0.0,
                expenses: 225000.0,
                balance: 25000.0,
                cars: [
                    { carNumber: "Е417ТХ/78", name: "Лизинг", value: -100000.0 },
                    { carNumber: "Е417ТХ/78", name: "ОСАГО", value: -15000.0 },
                    { carNumber: "Е417ТХ/78", name: "ТО-2", value: -25000.0 },
                ],
                trailers: [
                    { trailerNumber: "РС3867/78", name: "Реф", value: -10000.0 },
                    { trailerNumber: "РС3867/78", name: "Фреон", value: -5000.0 },
                    { trailerNumber: "РС3867/78", name: "Обслуживание", value: -5000.0 },
                ],
                drivers: [
                    { driverName: "Волков Г. Г.", name: "Зарплата", value: -50000.0 },
                    { driverName: "Волков Г. Г.", name: "Км", value: -5000.0 },
                    { driverName: "Волков Г. Г.", name: "Экономия", value: -5000.0 },
                ],
                bids: [
                    { bidId: 1000007, name: "Рефрижератор", value: 250000.0 },
                    { bidId: 1000007, name: "Санпаспорт", value: -2000.0 },
                    { bidId: 1000007, name: "Мойка кузова", value: -3000.0 },
                ],
            },
            {
                carNumber: "Х893АВ/12",
                incomes: 195000.0,
                expectedIncomes: 50000.0,
                debit: -20000.0,
                expenses: 138000.0,
                balance: 57000.0,
                cars: [
                    { carNumber: "Х893АВ/12", name: "Топливо", value: -70000.0 },
                    { carNumber: "Х893АВ/12", name: "AdBlue", value: -5000.0 },
                    { carNumber: "Х893АВ/12", name: "Лампочки", value: -1000.0 },
                ],
                trailers: [
                    { trailerNumber: "СУ7415/12", name: "Паллетник", value: -5000.0 },
                    { trailerNumber: "СУ7415/12", name: "Доски", value: -2000.0 },
                    { trailerNumber: "СУ7415/12", name: "Ремни", value: -3000.0 },
                ],
                drivers: [
                    { driverName: "Зайцев Д. Д.", name: "Зарплата", value: -45000.0 },
                    { driverName: "Зайцев Д. Д.", name: "Стоянки", value: -4000.0 },
                    { driverName: "Зайцев Д. Д.", name: "Душ", value: -1000.0 },
                ],
                bids: [
                    { bidId: 1000008, name: "Тент", value: 190000.0 },
                    { bidId: 1000008, name: "Простой", value: 5000.0 },
                    { bidId: 1000008, name: "Срыв", value: -2000.0 },
                ],
            },
            {
                carNumber: "М265КЕ/23",
                incomes: 294000.0,
                expectedIncomes: 55000.0,
                debit: 0.0,
                expenses: 136800.0,
                balance: 157200.0,
                cars: [
                    { carNumber: "М265КЕ/23", name: "ДТП", value: -48000.0 },
                    { carNumber: "М265КЕ/23", name: "Фара", value: -12000.0 },
                    { carNumber: "М265КЕ/23", name: "Бампер", value: -18000.0 },
                ],
                trailers: [
                    { trailerNumber: "ТХ2689/23", name: "Отбойник", value: -9000.0 },
                    { trailerNumber: "ТХ2689/23", name: "Номер", value: -1200.0 },
                    { trailerNumber: "ТХ2689/23", name: "Рамка", value: -600.0 },
                ],
                drivers: [
                    { driverName: "Соловьев Е. Е.", name: "Зарплата", value: -24000.0 },
                    { driverName: "Соловьев Е. Е.", name: "Удержание ДТП", value: -12000.0 },
                    { driverName: "Соловьев Е. Е.", name: "Штраф", value: -3000.0 },
                ],
                bids: [
                    { bidId: 1000009, name: "Юг", value: 294000.0 },
                    { bidId: 1000009, name: "Паром", value: -6000.0 },
                    { bidId: 1000009, name: "Платная дорога", value: -3000.0 },
                ],
            },
            {
                carNumber: "Н754ОТ/45",
                incomes: 224000.0,
                expectedIncomes: 40000.0,
                debit: 0.0,
                expenses: 96000.0,
                balance: 128000.0,
                cars: [
                    { carNumber: "Н754ОТ/45", name: "Топливо", value: -36000.0 },
                    { carNumber: "Н754ОТ/45", name: "Мойка ДВС", value: -1800.0 },
                    { carNumber: "Н754ОТ/45", name: "Химчистка", value: -4200.0 },
                ],
                trailers: [
                    { trailerNumber: "УА5394/45", name: "Пол", value: -9000.0 },
                    { trailerNumber: "УА5394/45", name: "Петли", value: -3000.0 },
                    { trailerNumber: "УА5394/45", name: "Замок", value: -1800.0 },
                ],
                drivers: [
                    { driverName: "Павлов Ж. Ж.", name: "Зарплата", value: -30000.0 },
                    { driverName: "Павлов Ж. Ж.", name: "Премия", value: -6000.0 },
                    { driverName: "Павлов Ж. Ж.", name: "Стаж", value: -3000.0 },
                ],
                bids: [
                    { bidId: 1000010, name: "Догруз 1", value: 112000.0 },
                    { bidId: 1000010, name: "Догруз 2", value: 112000.0 },
                    { bidId: 1000010, name: "Заезд", value: -1200.0 },
                ],
            },
            {
                carNumber: "Р382СМ/67",
                incomes: 280000.0,
                expectedIncomes: 85000.0,
                debit: 0.0,
                expenses: 250000.0,
                balance: 30000.0,
                cars: [
                    { carNumber: "Р382СМ/67", name: "Лизинг", value: -120000.0 },
                    { carNumber: "Р382СМ/67", name: "GPS", value: -2000.0 },
                    { carNumber: "Р382СМ/67", name: "Тахограф", value: -5000.0 },
                ],
                trailers: [
                    { trailerNumber: "ХВ6723/67", name: "ТО", value: -15000.0 },
                    { trailerNumber: "ХВ6723/67", name: "Колодки", value: -10000.0 },
                    { trailerNumber: "ХВ6723/67", name: "Смазка", value: -2000.0 },
                ],
                drivers: [
                    { driverName: "Киселев З. З.", name: "Зарплата", value: -60000.0 },
                    { driverName: "Киселев З. З.", name: "Суточные", value: -15000.0 },
                    { driverName: "Киселев З. З.", name: "Такси", value: -1000.0 },
                ],
                bids: [
                    { bidId: 1000011, name: "Дальний", value: 280000.0 },
                    { bidId: 1000011, name: "Командировка", value: -5000.0 },
                    { bidId: 1000011, name: "Гостиница", value: -15000.0 },
                ],
            },
            {
                carNumber: "В649УК/89",
                incomes: 196000.0,
                expectedIncomes: 32000.0,
                debit: 0.0,
                expenses: 115800.0,
                balance: 80200.0,
                cars: [
                    { carNumber: "В649УК/89", name: "Ремонт КПП", value: -48000.0 },
                    { carNumber: "В649УК/89", name: "Сцепление", value: -24000.0 },
                    { carNumber: "В649УК/89", name: "Работа", value: -12000.0 },
                ],
                trailers: [
                    { trailerNumber: "ЕК8419/89", name: "Стоянка", value: -3000.0 },
                    { trailerNumber: "ЕК8419/89", name: "Охрана", value: -1200.0 },
                    { trailerNumber: "ЕК8419/89", name: "Пропуск", value: -600.0 },
                ],
                drivers: [
                    { driverName: "Белов И. К.", name: "Минималка", value: -12000.0 },
                    { driverName: "Белов И. К.", name: "Простой", value: -3000.0 },
                    { driverName: "Белов И. К.", name: "Ожидание", value: -3000.0 },
                ],
                bids: [
                    { bidId: 1000012, name: "Межгород", value: 196000.0 },
                    { bidId: 1000012, name: "Неустойка", value: -6000.0 },
                    { bidId: 1000012, name: "Возврат", value: -3000.0 },
                ],
            },
            {
                carNumber: "К173ЕХ/90",
                incomes: 322000.0,
                expectedIncomes: 60000.0,
                debit: -28000.0,
                expenses: 141600.0,
                balance: 180400.0,
                cars: [
                    { carNumber: "К173ЕХ/90", name: "Лизинг", value: -66000.0 },
                    { carNumber: "К173ЕХ/90", name: "КАСКО", value: -15000.0 },
                    { carNumber: "К173ЕХ/90", name: "ОСАГО", value: -9000.0 },
                ],
                trailers: [
                    { trailerNumber: "КМ9537/90", name: "Штора", value: -3000.0 },
                    { trailerNumber: "КМ9537/90", name: "Ролики", value: -1800.0 },
                    { trailerNumber: "КМ9537/90", name: "Натяжитель", value: -1200.0 },
                ],
                drivers: [
                    { driverName: "Григорьев Л. Л.", name: "Зарплата", value: -33000.0 },
                    { driverName: "Григорьев Л. Л.", name: "Премия", value: -3000.0 },
                    { driverName: "Григорьев Л. Л.", name: "Доплата", value: -3000.0 },
                ],
                bids: [
                    { bidId: 1000013, name: "Кругорейс", value: 322000.0 },
                    { bidId: 1000013, name: "Суточные", value: -6000.0 },
                    { bidId: 1000013, name: "Связь", value: -600.0 },
                ],
            },
            {
                carNumber: "О528МР/11",
                incomes: 170000.0,
                expectedIncomes: 42000.0,
                debit: 0.0,
                expenses: 157000.0,
                balance: 13000.0,
                cars: [
                    { carNumber: "О528МР/11", name: "Топливо", value: -70000.0 },
                    { carNumber: "О528МР/11", name: "Мойка", value: -2000.0 },
                    { carNumber: "О528МР/11", name: "Шиномонтаж", value: -3000.0 },
                ],
                trailers: [
                    { trailerNumber: "МН3826/11", name: "Брызговик", value: -1000.0 },
                    { trailerNumber: "МН3826/11", name: "Лента", value: -2000.0 },
                    { trailerNumber: "МН3826/11", name: "Трос", value: -2000.0 },
                ],
                drivers: [
                    { driverName: "Кузьмин М. М.", name: "Зарплата", value: -50000.0 },
                    { driverName: "Кузьмин М. М.", name: "Аванс", value: -15000.0 },
                    { driverName: "Кузьмин М. М.", name: "Питание", value: -5000.0 },
                ],
                bids: [
                    { bidId: 1000014, name: "Попутный", value: 170000.0 },
                    { bidId: 1000014, name: "Комиссия", value: -5000.0 },
                    { bidId: 1000014, name: "Диспетчер", value: -2000.0 },
                ],
            },
            {
                carNumber: "Т946НС/22",
                incomes: 364000.0,
                expectedIncomes: 75000.0,
                debit: -32000.0,
                expenses: 159600.0,
                balance: 204400.0,
                cars: [
                    { carNumber: "Т946НС/22", name: "Лизинг", value: -66000.0 },
                    { carNumber: "Т946НС/22", name: "ТО", value: -12000.0 },
                    { carNumber: "Т946НС/22", name: "Страховка", value: -6000.0 },
                ],
                trailers: [
                    { trailerNumber: "ОТ7156/22", name: "Колодки", value: -9000.0 },
                    { trailerNumber: "ОТ7156/22", name: "Барабаны", value: -15000.0 },
                    { trailerNumber: "ОТ7156/22", name: "Работа", value: -6000.0 },
                ],
                drivers: [
                    { driverName: "Николаев Н. Н.", name: "Зарплата", value: -27000.0 },
                    { driverName: "Николаев Н. Н.", name: "Премия", value: -3000.0 },
                    { driverName: "Николаев Н. Н.", name: "Телефон", value: -600.0 },
                ],
                bids: [
                    { bidId: 1000015, name: "Север", value: 364000.0 },
                    { bidId: 1000015, name: "Переправа", value: -9000.0 },
                    { bidId: 1000015, name: "Зимник", value: -6000.0 },
                ],
            },
        ],
        footer: {
            debit: -335000.0,
            expectedIncomes: 8542192.9,
            expenses: 5234200.0,
            incomes: 6463000.0,
            balance: 1228800.0,
        },
        footerAdditionalInfo: null,
        generatedAt: "2025-12-10T13:27:13.7772974+00:00",
        errorMessage: null,
        onlyAdditionalFooter: false,
        id: "IncomesAndExpensesReport",
        name: "Отчет по доходам и расходам парка",
    });
};

export { accountsReceivableReportDemo, incomesAndExpensesReportDemo };
